import React from 'react';
import MenuCollapseItem from '../../MenuCollapseItem';
import { useMenu } from '../DesktopMenu';
import { UseCollapseReturn } from '../MobileMenu';
import RouteKey from '../../../routes/key';

const { admin } = RouteKey.child;

const {
  examConfiguration,
  announcementsConfiguration,
  accessArrangementConfiguration,
  featuresConfiguration,
  auditSettings,
  iExams2Configuration,
  configuration,
  dataArchival,
} = RouteKey.admin.child;

const adminSettingsPathDetails = [
  `/${admin}/${featuresConfiguration.route}`,
  `/${admin}/${auditSettings.route}`,
  `/${admin}/${iExams2Configuration.route}`,
  `/${admin}/${configuration.route}`,
];

const SettingMenuItem = ({
  collapseMenuItem10,
  menu10Handle,
  setMobileMenuOpen,
}: {
  collapseMenuItem10: UseCollapseReturn;
  menu10Handle: (evt: any) => void;
  setMobileMenuOpen: (value: boolean) => void;
}) => {
  const { history, checkMenuPathsInLocation, checkSubMenuPathInLocation } = useMenu();

  return (
    <MenuCollapseItem
      {...collapseMenuItem10}
      handleClick={menu10Handle}
      label="Settings"
      subMap={[
        {
          id: 'menu-settings-submenu-featuresConfiguration',
          label: 'Features Configuration',
          navigate: () => {
            setMobileMenuOpen(false);
            history.push(`/${admin}/${featuresConfiguration.route}`);
          },
          isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${featuresConfiguration.route}`),
        },
        {
          id: 'menu-settings-submenu-auditSettings',
          label: 'Audit Setting',
          navigate: () => {
            setMobileMenuOpen(false);
            history.push(`/${admin}/${auditSettings.route}`);
          },
          isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${auditSettings.route}`),
        },
        {
          id: 'menu-settings-submenu-systemsettings',
          label: 'System Settings',
          navigate: () => {
            setMobileMenuOpen(false);
            history.push(`/${admin}/${configuration.route}`);
          },
          isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${configuration.route}`),
        },
        {
          id: 'menu-settings-submenu-dataarchival',
          label: 'Data Archival',
          navigate: () => {
            setMobileMenuOpen(false);
            history.push(`/${admin}/${dataArchival.route}`);
          },
          isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${dataArchival.route}`),
        },
        {
          id: 'menu-settings-submenu-accessArrangementConfiguration',
          label: 'Access Arrangements Configuration',
          navigate: () => {
            setMobileMenuOpen(false);
            history.push(`/${admin}/${accessArrangementConfiguration.route}`);
          },
          isActiveSubMenu: checkSubMenuPathInLocation(
            `/${admin}/${accessArrangementConfiguration.route}`
          ),
        },
        {
          id: 'menu-settings-submenu-examConfiguration',
          label: 'Non-National Exam Configuration',
          navigate: () => {
            setMobileMenuOpen(false);
            history.push(`/${admin}/${examConfiguration.route}`);
          },
          isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${examConfiguration.route}`),
        },
        {
          id: 'menu-settings-submenu-announcementsConfiguration',
          label: 'Announcements Configuration',
          navigate: () => {
            setMobileMenuOpen(false);
            history.push(`/${admin}/${announcementsConfiguration.route}`);
          },
          isActiveSubMenu: checkSubMenuPathInLocation(
            `/${admin}/${announcementsConfiguration.route}`
          ),
        },
      ]}
      isActiveMenu={checkMenuPathsInLocation(adminSettingsPathDetails)}
    />
  );
};
export default SettingMenuItem;
